module.exports = "export default __webpack_public_path__ + &quot;ade24379e2353ab0cce3263a869cf258.svg&quot;;"